<template>
	<el-card class="ring-chart-card">
		<div class="chart-title">存量资产性质占比</div>
		<div class="chart-wrapper" ref="chart"></div>
	</el-card>
</template>

<script>
	import * as echarts from 'echarts';
	import apis from '@/http/apis';
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入点击事件

	const PRESET_COLORS = ['#28c700', '#ff5e5e', '#ffb800', '#00d3f0', '#ab47bc', '#2196f3'];

	// 解码后端返回的 \uXXXX 字面量字符串
	function decodeUnicode(str) {
		if (typeof str !== 'string') return str;
		return str.replace(/\\u([0-9a-fA-F]{4})/g, (_, code) => String.fromCharCode(parseInt(code, 16)));
	}

	export default {
		mixins: [chartClickMixin],
		name: 'StockAssetNaturePieChart',
		data() {
			return {
				chart: null,
				chartData: []
			};
		},
		created() {
			this.loadData();
		},
		mounted() {
			this.initChart();
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			loadData() {
				apis.stockAssetNature().then((res) => {
					console.log('[资产信息轮播表] 接口返回数据:', res);
					const list = res && res.data && res.data.list ? res.data.list : [];
					if (list.length) {
						this.chartData = list.map((item, index) => ({
							value: item.ratio,
							name: decodeUnicode(item.name),
							itemStyle: { color: PRESET_COLORS[index % PRESET_COLORS.length] }
						}));
						this.updateChart();
					}
				});
			},
			initChart() {
				this.chart = echarts.init(this.$refs.chart);
				this.updateChart();
				window.addEventListener('resize', this.handleResize);
			},
			updateChart() {
				if (!this.chart) return;
				const option = {
					legend: {
						bottom: '10',
						left: 'center',
						textStyle: { color: '#ffffff' },
						itemWidth: 12,
						itemHeight: 12,
						itemStyle: { borderWidth: 0 },
						formatter: (name) => `${name}(处)`
					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['40%', '50%'],
						center: ['50%', '35%'],
						avoidLabelOverlap: false,
						itemStyle: { borderRadius: 0, borderColor: '#fff', borderWidth: 0 },
						label: {
							show: true,
							position: 'outside',
							formatter: (params) => {
								return `{title|${params.name}(处)}\n{value|${params.percent}%}`;
							},
							rich: {
								title: { fontSize: 12, color: '#fff', padding: [2, 0, 0, 0] },
								value: { fontSize: 12, color: '#fff', fontWeight: 'bold', padding: [2, 0, 0, 0] }
							}
						},
						emphasis: {
							label: { show: true, fontSize: '12', fontWeight: 'bold' }
						},
						labelLine: { show: true, length: 5, length2: 5 },
						data: this.chartData.length ? this.chartData : [
							{ value: 0.20, name: '外部委托', itemStyle: { color: '#28c700' } },
							{ value: 0.35, name: '自有资产', itemStyle: { color: '#ff5e5e' } },
							{ value: 0.25, name: '内部委托', itemStyle: { color: '#ffb800' } },
							{ value: 0.20, name: '租入资产', itemStyle: { color: '#00d3f0' } }
						]
					}]
				};
				this.chart.setOption(option);
				this.setupChartClick(this.chart, 'echarts');
			},
			handleResize() {
				if (this.chart) {
					this.chart.resize();
				}
			}
		}
	};
</script>

<style scoped>
	.ring-chart {
		width: 100%;
		height: calc(100% - 0px);
	}

	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 40%);
	}


	.ring-chart-card {
		width: 100%;
		height: calc(100% - 40px);
		background: transparent;
		border: none;
	}

	.ring-chart-card /deep/ .el-card__body {
		width: 100%;
		height: 100%;
		padding: 0px;
	}

	.chart-wrapper {
		width: 100%;
		height: calc(100% - 30px);
	}

	.chart-title {
		font-size: 14px;
		font-weight: 600;
		color: #fff;
		height: 20px;
		margin: 5px 5px;
	}
</style>